<template>
  <div class="home flex flex-col justify-center items-center pb-5 pt-4">
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'AboutView',
  components: {
    // HelloWorld
  },
  created () {
  },
  mounted () {

  },
  methods: {
    goback () {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
